<template>
  <div class="panel">
    <div class="controls" :class="{white: panel.backgroundColour === 'black'}">
      <div class="right">
        <i class="fas fa-minus" @click="dec(true)"></i>
        <i class="fas fa-plus" @click="inc(true)"></i>
      </div>
      <div class="bottom">
        <i class="fas fa-minus" @click="dec(false)"></i>
        <i class="fas fa-plus" @click="inc(false)"></i>
      </div>
      <div class="topRight">
        <i class="fas fa-trash-alt" @click="deletePanel()"></i>
        <i class="fas fa-copy" @click="copy()"></i>
      </div>
      <div class="topLeft">
        <i class="fas fa-wrench" @click="configure()"></i>
      </div>
    </div>
    <div class="content" :style="{'background-color':panel.backgroundColour || 'white'}">
      <component :is="panel.type" :panel="panel" :data="data" :definition="definition" :height="height"></component>
    </div>
  </div>
</template>

<script>
import Graph from "./contents/Graph";
import List from "./contents/List";
import Stat from "./contents/Stat";
import Timepanel from "./contents/Time";
import axios from "../../utils/axios";
import moment from "moment-timezone";
import { setInterval, clearInterval } from "timers";

export default {
  props: ["panel", "save", "index", "deletePanel", "configure", "definitions", "wallboardId", "copy", "height"],
  components: { Graph, List, Stat, Timepanel },
  data() {
    return {
      colours: ["red", "blue", "green", "yellow", "orange", "white"],
      definition: undefined,
      timer: undefined,
      data: undefined
    };
  },
  destroyed() {
    clearInterval(this.timer);
  },
  created() {
    if (this.panel.statDefinitionId) {
      this.definition = this.definitions.find(d => d.id === this.panel.statDefinitionId);
      if (this.definition) {
        this.timer = setInterval(this.getData, this.definition.defaultRefreshFrequency);
      }
    } else if (this.panel.type === "timepanel") {
      this.timer = setInterval(this.getData, 500);
    }
  },
  watch: {
    "panel.statDefinitionId": function(val) {
      this.definition = this.definitions.find(d => d.id === val);
    }
  },
  methods: {
    inc(width) {
      if (width) {
        if (this.panel.width !== 12) this.panel.width++;
      } else {
        if (this.panel.height !== 12) this.panel.height++;
      }
      this.save();
    },
    dec(width) {
      if (width) {
        if (this.panel.width > 1) this.panel.width--;
      } else {
        if (this.panel.height > 1) this.panel.height--;
      }
      this.save();
    },
    getData() {
      if (this.panel.type === "timepanel") {
        this.data = moment()
          .tz(this.panel.timezone || "")
          .format("HH:mm:ss");
      } else {
        if (!this.definition) return;
        let filters = [];
        if (this.definition.filters && this.definition.filters.length) {
          this.definition.filters.forEach(filter => {
            let value;
            if (this.panel.filters && this.panel.filters[filter.id] !== undefined && this.panel.filters[filter.id] !== "") {
              value = this.panel.filters[filter.id];
            } else if (filter.defaultValue) {
              value = filter.defaultValue;
            }
            if (value !== undefined) {
              filters.push({
                name: filter.name,
                value
              });
            }
          });
        }
        axios.post("wallboards/" + this.wallboardId + "/data", { panel: this.panel, filters }).then(response => {
          let data = response && response.data && response.data.result && response.data.result.value
          if (parseInt(data))
            data = parseInt(data)
          this.data = data
        });
      }
    }
  }
};
</script>

<style>
</style>
